import React from "react"; 
export   function MyResultSvg() {  
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="124" height="124" viewBox="0 0 124 124" fill="none">
            <path d="M122 122L92.3762 92.3762M107.882 54.9412C107.882 25.7025 84.1795 2 54.9412 2C25.7025 2 2 25.7025 2 54.9412C2 84.1795 25.7025 107.882 54.9412 107.882C84.1795 107.882 107.882 84.1795 107.882 54.9412Z" stroke="black" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M50.7828 55.9997L35 71.7828L39.217 76L55 60.217L70.7828 76L75 71.7828L59.2172 55.9997L74.9996 40.2171L70.7824 36L55 51.7825L39.2175 36L35.0005 40.2171L50.7828 55.9997Z" fill="#E31335" />
        </svg>
    );
}